export default function TextLink(props) {
    return (
        <>
            <a className="cursor-pointer dark:hover:text-yellow-400 dark:hover:bg-yellow-100/5 hover:text-blue-700 hover:bg-blue-800/20"
                style={{ textDecoration: 'none', borderBottom: '1px dotted currentColor' }}
                target={props.sameTab ? '' : '_blank'}
                rel="noreferrer"
                href={props.link}>
                {props.children}
            </a>
            <sup className={`${props.super ? 'font-mono' : 'font-sans'} leading-[0] text-[10px] font-light dark:text-yellow-300 text-blue-700`}>
                {props.super ? props.super : '↗'}
            </sup>
        </>
    );
}